import PaginatedEntityTable from "./PaginatedEntityTable";
import useTableFetchContext from "./useTableFetchContext";
export { useTableFetchContext };
export default PaginatedEntityTable;
